export const updateShowButtons = (number) => (dispatch, getState) => {
  if (getState().activities.home.showButtons === number) {
    dispatch({
      type: 'SHOW_ACTIVITIES_BUTTONS',
      payload: 0
    });
  } else {
    dispatch({
      type: 'SHOW_ACTIVITIES_BUTTONS',
      payload: number
    });
  }
};
